import { message, Select, Input, Modal, Form } from 'antd';
import React, { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { waBuyerBind } from 'services/api/waBuyers';
import toLowerCase from 'utils/toLowerCase';
import useRegionList from 'components/StoreSelector/hooks/useRegionList';
import { useGetRegionLabel } from 'hooks/business/useRegion';

export type TPlatform = 'SHOPEE' | 'LAZADA';

const ModalBind = ({
  phone,
  visModalBuyer,
  setVisModalBuyer,
  setVisDrawer,
  setRefreshAgain,
}: {
  phone?: string;
  visModalBuyer: boolean;
  setVisModalBuyer: React.Dispatch<React.SetStateAction<boolean>>;
  setVisDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  setRefreshAgain: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslate();
  const getRegionLabel = useGetRegionLabel();

  const { regionsMap } = useRegionList();

  const [platformInForm, setPlatformInForm] = useState<TPlatform | undefined>();

  const [form] = Form.useForm();

  return (
    <Modal
      destroyOnClose
      title={t('WhatsappBuyers.关联平台')}
      visible={visModalBuyer}
      onCancel={() => {
        setVisModalBuyer(false);
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            const reqData = { ...values, phone };
            waBuyerBind(reqData)
              .then((num) => {
                setRefreshAgain((v) => v + 1);
                if (num === 0) {
                  message.error(t('WhatsappBuyers.未找到该买家信息'));
                } else {
                  message.success(t('WhatsappBuyers.已关联几个店铺', { num }));
                  setVisModalBuyer(false);
                  setVisDrawer(false);
                }
              })
              .catch((e) => {
                message.error(t('translation.操作失败，请稍后再试'));
              });
          })
          .catch(() => {});
      }}
    >
      <Form form={form} layout="vertical" autoComplete="off" preserve={false}>
        <Form.Item
          name="platform"
          label={t('WhatsappBuyers.选择平台')}
          rules={[{ required: true, message: '' }]}
        >
          <Select
            placeholder={t('WhatsappBuyers.选择平台')}
            allowClear
            options={[{ value: 'SHOPEE' }, { value: 'LAZADA' }]}
            onChange={(v) => {
              if (!v) {
                const formValue = form.getFieldsValue();
                formValue.region = undefined;
                form.setFieldsValue(formValue);
              }
              setPlatformInForm(v);
            }}
          />
        </Form.Item>
        <Form.Item
          name="region"
          label={t('WhatsappBuyers.选择站点')}
          rules={[{ required: true, message: '' }]}
        >
          <Select
            disabled={!platformInForm}
            placeholder={t('WhatsappBuyers.选择站点')}
            allowClear
            options={
              platformInForm
                ? regionsMap[toLowerCase(platformInForm)].map((v) => ({
                    value: v,
                    label: getRegionLabel(v),
                  }))
                : []
            }
          />
        </Form.Item>
        <Form.Item
          name="buyerNick"
          label={t('remind.买家昵称')}
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
        >
          <Input placeholder={t('trade.请输入')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalBind;
